import { useEffect, useState, useContext, useRef } from "react";
import toast from "react-hot-toast";
import { ClientContext } from "ClientProvider";
import { useLocation } from "react-router-dom";
import PayoutList from "./components/PayoutList"
import AddBatchFile from "./components/AddBatchFile";
import { getPayout } from "api/graphQL_crypto"
import PaymentTable from "./components/PaymentsList";
import { getCryptoPayoutsFilter } from "api/payouts";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import {  getCardType } from "api/graphQL_payments";
export interface PayoutRowObj {
    id:any;
    createdAt:any;
    batchId: any;
    clientId: any;
    clientName: any;
    gatewayId:any;
    gatewayName:any;
    totalTransactions:any;
    gateway:any;
    totalAmount:any;
    currency:any;
    transations:any;
    type:any
}


export type PaymentRowObj = {
  id: string;
  payment_id: string;
  et_id: string;
  amount: string;
  crypto_amount: string;
  fiat_amount: string;
  currency: string;
  crypto_currency: string;
  fiat_currency: string;
  gateway_id: string;
  gateway_name: string;
  status: string;
  meta_info: any;
  gateway_response: any;
  payment_type: string;
  client_name: string;
  refund_info: string;
  created_at: string;
  image: string;
  all_data: any[];
  expanded: boolean;
  payment_history: any;
};

const CryptoPayout = () => {

    const [page, setPage] = useState<number>(1);
    const [batchPage, setBatchPage] = useState<number>(1);
    const [payouts, setPayouts] = useState<PayoutRowObj[]>([]);
    const [totalpage, setTotalPage] = useState<number>(0);
    const [batchTotalpage, setBatchTotalPage] = useState<number>(0);
    const [totalItems, setTotalItems] = useState<number>(1);
    const [batchTotalItems, setBatchTotalItems] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(50);
    const [batchPageSize, setBatchPageSize] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [batchCurrentPage, setBatchCurrentPage] = useState<number>(1);
    const [searchTexts, setSearchTexts] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { singleRoleData, setSingleRoleData , setFilter, filter } = useContext(ClientContext);
    const location = useLocation();
    const [clients, setClients] = useState();
    const [localFilters, setLocalFilters] = useState<any>({});
    const [clearClicked,setClearClick] = useState(0)
    const { activeTab, setActiveTab } = useContext(ClientContext);
    const hasSinglePayoutPermission =  singleRoleData?.[0]?.crypto?.value?.view_single_crypto_payout_list;
    const hasBatchPayoutPermission = singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_list;
    const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>();
    const [payments, setPayments] = useState<PaymentRowObj[]>([]);
    const [value, setValue] = useState(false);
    const { paymentType } = useContext(ClientContext);
    const [curretClient, setCurrentClient] = useState<string>("all");
    const [allGateways, setAllGateways] = useState();
    const [allCardType, setCardType] = useState();
    const initialRender = useRef(true);
    const isResetting = useRef(false);
    const fetchPayouts = () => {
        let finalSearchText = ""
        if(location.state) {
        if (location.state?.search) {
            finalSearchText = location.state.search
            window.history.replaceState({}, document.title);
        }
        } else {
            finalSearchText = searchTexts;
        }
        const params = { page: batchPage, per_page: batchPageSize, searchTexts: finalSearchText };
        if (batchPageSize === null || batchPageSize === undefined) {
        setIsLoading(false);
        return;
        }
        setIsLoading(true);
        getPayout(params)
        .then((data:any) => {
            if(data.status == "Error") {
                setPayouts([]);
                setBatchTotalPage(1)
                setBatchTotalItems(1)
                setBatchCurrentPage(1)
            } else {
                setPayouts(data?.[0]);
                setBatchTotalPage(data?.[1].total_pages);
                setBatchTotalItems(data?.[1].total_items);
                setBatchCurrentPage(data?.[1].current_page);
            }
        })
        .catch((err) => {
            setPayouts([]);
            setIsLoading(false);
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        if(activeTab == "batch" || (!hasSinglePayoutPermission && hasBatchPayoutPermission)) {
            fetchPayouts();
        }
    }, [batchPage, batchPageSize, searchTexts,clearClicked,activeTab]);

    useEffect(() => {
        isResetting.current = true;
        setPage(1);
        setBatchPage(1);
        setPageSize(50);
        setBatchPageSize(50);
        setValue(!value);
    }, [paymentType, filter?.status, searchTexts,activeTab]);

    const filterData = () => {
        setIsPaymentLoading(true);
        getCryptoPayoutsFilter(
            page,
            pageSize,
            searchTexts
        )
            .then((data) => {
            setPayments(data.data);
            setTotalPage(data.total_pages);
            setTotalItems(data.total_items);
            setCurrentPage(data.current_page);
            })
            .catch((err) => {
            toast.error(
                err?.response?.data?.message ??
                "Something went wrong while fetching payout list"
            );
            })
            .finally(() => {
            setIsPaymentLoading(false);
            });
        };


    const fetchAllGateways = () => {
        // setIsLoading(true);
        getAllGatewaysSecond()
            .then((data) => {
            setAllGateways(data);
            })
            .catch((err) => {
            toast.error(
                err?.response?.data?.message ??
                "Something went wrong while fetching AllGateways"
            );
            })
            .finally(() => {
            // setIsLoading(false);
            });
        };
    
        const fetchCardType = () => {
        // setIsLoading(true);
        getCardType()
            .then((data) => {
            setCardType(data);
            })
            .catch((err) => {
            toast.error(
                err?.response?.data?.message ??
                "Something went wrong while fetching CardType"
            );
            })
            .finally(() => {
            // setIsLoading(false);
            });
        };
    useEffect(() => {

        if (initialRender.current) {
            initialRender.current = false;
            return;
        }

        if (isResetting.current) {
            isResetting.current = false;
            return;
        }
        if (page !== 0 && activeTab === "single") {
            filterData();
        }
    }, [page, curretClient, pageSize, value,clearClicked,activeTab,searchTexts]);

    useEffect(() => {
    fetchAllGateways();
    fetchCardType();
    filterData();
    }, []);
    
    const serchboxValueChange = async (searchTerm: string) => {
        const search_txt = searchTerm || "";
    
        if (search_txt !== searchTexts && searchTexts !== "") {
          await setSearchTexts(search_txt);
          setPage(1);
          setCurrentPage(1);
        } else {
          await setSearchTexts(search_txt);
        }
    };

    const onClearClick = () => {
        setClearClick((prev) => {
          const newCount = prev + 1;
          return newCount;
        });
    };

    return (
        <>
            <div className="w-full  mx-auto mt-5 pt-5">
                {hasSinglePayoutPermission && hasBatchPayoutPermission ? (
                    <>
                        
                        <div className="relative flex w-1/3 bg-gray-100 dark:bg-gray-800 p-1 rounded-2xl shadow-inner  mb-2">
                            <div
                                className="absolute top-1 bottom-1 w-[49.1%] transition-all duration-300 ease-out rounded-2xl bg-white dark:bg-gray-700"
                                style={{
                                transform: activeTab === "single" ? "translateX(0%)" : "translateX(100%)",
                                boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
                                }}
                            ></div>
                            <button
                                onClick={() => setActiveTab("single")}
                                className={`relative z-10 w-1/2 text-sm font-semibold py-3 transition-colors duration-300 rounded-2xl ${
                                activeTab === "single"
                                    ? "text-indigo-600 dark:text-indigo-400"
                                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                                }`}
                            >
                                Single Payout
                            </button>
                            <button
                                onClick={() => setActiveTab("batch")}
                                className={`relative z-10 w-1/2 text-sm font-semibold py-3 transition-colors duration-300 rounded-2xl ${
                                activeTab === "batch"
                                    ? "text-indigo-600 dark:text-indigo-400"
                                    : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                                }`}
                            >
                                Batch Payout
                            </button>
                        </div>
                        <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-lg p-6 transition-all duration-300">
                            {activeTab === "single" && (
                                <>
                                    <PaymentTable
                                        pageSize={pageSize}
                                        setPageSize={setPageSize}
                                        tableData={payments}
                                        fetchPayments={filterData}
                                        isLoading={isPaymentLoading}
                                        page={page}
                                        setPage={setPage}
                                        totalpage={totalpage}
                                        totalItems={totalItems}
                                        currentPage={currentPage}
                                        clients={clients}
                                        allGateways={allGateways}
                                        allCardType={allCardType}
                                        curretClient={curretClient}
                                        setCurrentClient={setCurrentClient}
                                        roleData={singleRoleData}
                                        filterData={filterData}
                                        setClearClick={onClearClick}
                                        filter={filter}
                                        setFilter={setFilter}
                                        onValueChange={serchboxValueChange}
                                        setLocalFilters={setLocalFilters}
                        
                                    />
                                </>
                            )}

                            {activeTab === "batch" && (
                                <>
                                    <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                                        <AddBatchFile 
                                        fetchPayouts={fetchPayouts}
                                        />
                                    </div>
                                    <div className="mt-5">
                                        <PayoutList 
                                            tableData={payouts}
                                            fetchPayouts={fetchPayouts}
                                            isLoading={isLoading}
                                            roleData={singleRoleData}
                                            onValueChange={serchboxValueChange}
                                            page={batchPage}
                                            setPage={setBatchPage}
                                            totalpage={batchTotalpage}
                                            totalItems={batchTotalItems}
                                            currentPage={batchCurrentPage}
                                            pageSize={batchPageSize}
                                            setPageSize={setBatchPageSize}
                                            setLocalFilters={setLocalFilters}
                                            filterData={fetchPayouts}
                                            localFilters={localFilters}
                                            filter={filter}
                                            setFilter={setFilter}
                                            setClearClick={onClearClick}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                    ) : hasSinglePayoutPermission ? (
                        <div className="mt-5 pt-5">
                            <PaymentTable
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                tableData={payments}
                                fetchPayments={filterData}
                                isLoading={isPaymentLoading}
                                page={page}
                                setPage={setPage}
                                totalpage={totalpage}
                                totalItems={totalItems}
                                currentPage={currentPage}
                                clients={clients}
                                allGateways={allGateways}
                                allCardType={allCardType}
                                curretClient={curretClient}
                                setCurrentClient={setCurrentClient}
                                roleData={singleRoleData}
                                filterData={filterData}
                                setClearClick={onClearClick}
                                filter={filter}
                                setFilter={setFilter}
                                onValueChange={serchboxValueChange}
                                setLocalFilters={setLocalFilters}
                
                            />
                        </div>
                    ) : hasBatchPayoutPermission ? (
                        <>
                            <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                                <AddBatchFile 
                                fetchPayouts={fetchPayouts}
                                />
                            </div>
                            <div className="mt-5">
                                <PayoutList 
                                    tableData={payouts}
                                    fetchPayouts={fetchPayouts}
                                    isLoading={isLoading}
                                    roleData={singleRoleData}
                                    onValueChange={serchboxValueChange}
                                    page={page}
                                    setPage={setPage}
                                    totalpage={totalpage}
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    pageSize={pageSize}
                                    setPageSize={setPageSize}
                                    setLocalFilters={setLocalFilters}
                                    filterData={fetchPayouts}
                                    localFilters={localFilters}
                                    filter={filter}
                                    setFilter={setFilter}
                                    setClearClick={onClearClick}
                                />
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
            </div>
        </>
    )
}

export default CryptoPayout;